/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LivePlayEndInput } from '../models/LivePlayEndInput';
import type { LivePlayInput } from '../models/LivePlayInput';
import type { LivePlayOutput } from '../models/LivePlayOutput';
import type { LivePlayUpdateInput } from '../models/LivePlayUpdateInput';
import type { PlayOutput } from '../models/PlayOutput';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class LivePlaysService {
    /**
     * Get Active Live Plays
     * Get all active live play sessions (started within last 24 hours)
     * @returns LivePlayOutput Successful Response
     * @throws ApiError
     */
    public static getLivePlaysLivePlaysGet({
        leagueId,
    }: {
        /**
         * Filter by league ID
         */
        leagueId?: string,
    }): CancelablePromise<Array<LivePlayOutput>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/live-plays',
            query: {
                'league_id': leagueId,
            },
        });
    }
    /**
     * Create Live Play
     * Start a new live play session
     * @returns LivePlayOutput Successful Response
     * @throws ApiError
     */
    public static createLivePlayLivePlaysPost({
        requestBody,
    }: {
        requestBody: LivePlayInput,
    }): CancelablePromise<LivePlayOutput> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/live-plays',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request - game not found or invalid players`,
                500: `Server error`,
            },
        });
    }
    /**
     * Get Live Play
     * Get a single live play session
     * @returns LivePlayOutput Successful Response
     * @throws ApiError
     */
    public static getLivePlayLivePlaysLivePlayIdGet({
        livePlayId,
    }: {
        livePlayId: string,
    }): CancelablePromise<LivePlayOutput> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/live-plays/{live_play_id}',
            path: {
                'live_play_id': livePlayId,
            },
            errors: {
                404: `Live play not found`,
            },
        });
    }
    /**
     * Update Live Play
     * Add events to an active live play session (intermediate scores, notes, metadata)
     * @returns LivePlayOutput Successful Response
     * @throws ApiError
     */
    public static updateLivePlayLivePlaysLivePlayIdPatch({
        livePlayId,
        requestBody,
    }: {
        livePlayId: string,
        requestBody: LivePlayUpdateInput,
    }): CancelablePromise<LivePlayOutput> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/live-plays/{live_play_id}',
            path: {
                'live_play_id': livePlayId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Forbidden - user is not a participant in this live play`,
                404: `Live play not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Cancel Live Play
     * Cancel/abandon a live play session without creating a play record
     * @returns any Successful Response
     * @throws ApiError
     */
    public static cancelLivePlayLivePlaysLivePlayIdDelete({
        livePlayId,
    }: {
        livePlayId: string,
    }): CancelablePromise<{
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/live-plays/{live_play_id}',
            path: {
                'live_play_id': livePlayId,
            },
            errors: {
                403: `Forbidden - user is not a participant in this live play`,
                404: `Live play not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * End Live Play
     * End a live play session and create a regular play record with results
     * @returns PlayOutput Successful Response - returns the created Play
     * @throws ApiError
     */
    public static endLivePlayLivePlaysLivePlayIdEndPost({
        livePlayId,
        requestBody,
    }: {
        livePlayId: string,
        requestBody: LivePlayEndInput,
    }): CancelablePromise<PlayOutput> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/live-plays/{live_play_id}/end',
            path: {
                'live_play_id': livePlayId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request - missing ranking or invalid data`,
                403: `Forbidden - user is not a participant in this live play`,
                404: `Live play not found`,
                500: `Server error`,
            },
        });
    }
}
